import {
  useTranslation
} from "../../../../chunk-6N4NEKWU.mjs";
import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ClarifyingQuestions/ClarifyingQuestionsHeader.tsx
import { Text } from "../../../primitive/index.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function ClarifyingQuestionsHeader({ children, titleRef }) {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "buyscout-clarifying-header", children: [
    /* @__PURE__ */ jsxs("div", { className: "buyscout-clarifying-header-left", children: [
      /* @__PURE__ */ jsx("span", { className: "buyscout-timeline-header-icon", "aria-hidden": "true", children: /* @__PURE__ */ jsx("span", { className: "buyscout-clarifying-header-question", children: "?" }) }),
      /* @__PURE__ */ jsx(Text, { ref: titleRef, tabIndex: titleRef ? -1 : void 0, variant: "body-bold", as: "span", className: "buyscout-clarifying-title", children: t("clarifyingQuestions.heading") })
    ] }),
    children
  ] });
}
export {
  ClarifyingQuestionsHeader
};
//# sourceMappingURL=ClarifyingQuestionsHeader.mjs.map